function initSingleMitigation() {
  // Select all elements with tabindex greater than 0
  $('[tabindex]').filter(function() {
    return $(this).attr('tabindex') > 0;
  }).attr('tabindex', '0');
  // End tabindex statement
  
  if ($('.single-mitigation').length == 0) {
    return false;
  }

  const backButton = $('#mitigation-back');
  const prevUrl = document.referrer;

  if (prevUrl.indexOf('?') > -1) {
    backButton.on('click', function () {
      history.go(-1);
    });
  } else {
    backButton.on('click', function () {
      location.href = backButton.data('url');
    });
  }
}

export { initSingleMitigation }


// WEBPACK FOOTER //
// ./scripts/pages/single-mitigation.js